import { TPromoCompilationType } from '../../types/promoSelection';
import { IApplicationState } from '../../types/redux';

export const selectPromoCompilationUrl =
  (type: TPromoCompilationType) =>
  (state: IApplicationState): string => {
    const {
      promosPage: { lastChanceDiscount, topPromos },
    } = state;
    switch (type) {
      case 'topPromos':
        return topPromos.url;
      case 'lastChanceDiscount':
        return lastChanceDiscount.url;
    }
  };
